module.exports = __webpack_public_path__ + "ads.txt";